module.exports = __webpack_public_path__ + "static/img/pay_visa.9a86670.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order/pay_visa.png
// module id = D7pl
// module chunks = 0